import React from "react";
import { useLocation, useParams,useNavigate } from "react-router-dom";

const countryNames = ['Bosnia and Herzegovina','Kosovo','Montenegro','North Macedonia','Serbia']
const countryBackgroundimages = ['/images/jpg/bosnia-herzegovina.jpg','/images/jpg/kosovo.jpg','/images/jpg/montenegro.jpg','/images/webp/north-macedonia-flag.webp','/images/jpg/serbia.webp']


function AreaMacedoniaBanner() {

  const params = useParams();

  const location = useLocation();
  const navigate = useNavigate();


  return (
    <section className="country-banner">
      <div
        className="banner-details"
        style={{ backgroundImage: `url(/images/jpg/${params?.country?.toLowerCase().replace(/ /g, "-")}.jpg` }}
      >
        <div className="d-sm-flex align-items-center justify-content-between gap-1 position-relative">
          <h2 className="f-s-36 f-w-400"><span onClick={() => navigate(`/country/${params?.country}`)}>{params?.country}</span> &gt;  <span onClick={() => navigate(`/area/${params?.country}/${params?.area}`,{state : location?.state})}>{params?.area}</span></h2>
          <div>
            <img src={location?.state?.img} className="img-fluid" alt="" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default AreaMacedoniaBanner;
